<div class="cell small-12">
  <label>
    <div class="label-text">Choose Default Value</div>
    @if (getDomainValues(); as domains) {
      <select [(ngModel)]="componentData.defaultValue" [disabled]="isLoading">
        <option [ngValue]="undefined">Not Set</option>
        @for (domain of domains; track domain) {
          <option [ngValue]="domain[componentData.config.idProperty]">{{domain[componentData.config.idProperty]}}: {{domain[componentData.config.displayProperty]}}</option>
        }
      </select>
    } @else {
      Please configure a Domain in the Data tab.
    }
  </label>
</div>